import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'

/**
 * Root setup — deliberately minimal.
 *
 * ClerkProvider USED to live here, which meant Clerk's ~165KB SDK was
 * downloaded on every single page including /, /jannercard, /privacy,
 * /terms, /f/:slug, and 404. Now ClerkProvider lives inside AuthShell
 * (a lazy chunk) and only loads when a visitor reaches an auth route.
 *
 * HelmetProvider stays at the root because every page sets its own
 * <Helmet> tags (titles, canonicals, OG meta) and the provider is
 * a tiny dependency. BrowserRouter likewise stays here so all routes
 * have a routing context.
 */

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
)
